import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

import type { CreateCashCollectionFormSchemaValues } from 'src/features/cashCollections/hooks/useCreateCashCollection';
import type { CreateCashCollections } from 'src/features/cashCollections/types/cashCollections';
import type { MutationConfig } from 'src/lib/react-query';
import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/cash-collection/cash-collection/:id/';

interface DTO extends Partial<Record<keyof CreateCashCollectionFormSchemaValues, any>> {
    id: string;
    status?: 'paid' | 'collected';
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ id, ...data }: DTO): Promise<CreateCashCollections> => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (key === 'files' && Array.isArray(value)) {
            value.forEach((file) => {
                formData.append('files', file); // append multiple files
            });
        } else {
            formData.append(key, value);
        }
    });

    return axios.patch(formatResourcePath(RESOURCE, { id }), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_CASH_COLLECTION_RESOURCE, useMutationHook as useUpdateCashCollection };
export type {
    DTO as UpdateCashCollectionDTO,
    CreateCashCollectionFormSchemaValues as UpdateMembershipGroupMemberFormSchemaValues,
};
